import React, { memo, useContext, useMemo, useCallback } from 'react';
import { BottomSheet, Header } from '@yme/atoms/bottom-sheet';
import { Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { RadioButton } from '@yme/atoms/radio-button';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FilterDropdownContext, FilterClearAll } from '@yme/molecules/filter-dropdown';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel2, RegularTextLevel4 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
import { setCheckedStateForAll } from '../CheckboxesDropdown/helpers';
import { FilterListStyled, FilterListWrapperStyled, FilterItemDesktopStyled, } from '../CheckboxesDropdown/styled';
export const RadioButtonsDropdown = memo(({ isRightToLeft, name, clearAllLabel, confirmLabel, onChange }) => {
    const { options, isExpanded, titleLabel, setOptions, setIsExpanded } = useContext(FilterDropdownContext);
    const { isInfiniteDesktopView: isDesktop } = useWindowSize();
    const isSomeSelected = useMemo(() => options.some((item) => item.checked), [options]);
    const onOptionChange = useCallback((event) => {
        const { value } = event.target;
        const data = options.map((option) => ({
            ...option,
            checked: option.value === value,
        }));
        setOptions(data);
        onChange(data);
    }, [onChange, options, setOptions]);
    const clearSelected = useCallback(() => {
        const data = setCheckedStateForAll(options, false);
        setOptions(data);
        onChange(data);
    }, [onChange, options, setOptions]);
    const handleCloseBottomSheet = useCallback(() => {
        setIsExpanded(false);
    }, [setIsExpanded]);
    const radioButtonItems = useMemo(() => options.map(({ value, label, checked, additionalText }, index) => (React.createElement(FilterItemDesktopStyled, { key: buildKey(value, index) },
        React.createElement(RadioButton, { id: value, name: name, onChange: onOptionChange, value: value, label: label, isRightToLeft: isRightToLeft, isChecked: checked }),
        additionalText && (React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, additionalText))))), [isRightToLeft, name, onOptionChange, options]);
    const ListDesktop = useMemo(() => {
        if (!isExpanded) {
            return null;
        }
        return (React.createElement(FilterListWrapperStyled, null,
            React.createElement(FilterListStyled, { isRightToLeft: isRightToLeft }, radioButtonItems),
            isSomeSelected && (React.createElement(FilterClearAll, { isRightToLeft: isRightToLeft, onClickHandler: clearSelected, clearLabel: clearAllLabel }))));
    }, [clearAllLabel, clearSelected, isExpanded, isRightToLeft, isSomeSelected, radioButtonItems]);
    const ListMobile = useMemo(() => (React.createElement(BottomSheet, { open: isExpanded, onDismiss: handleCloseBottomSheet, header: React.createElement(Header, { headerLeft: React.createElement(RegularTextLevel2, { weight: 500 }, titleLabel) }), footer: React.createElement(Button, { size: SIZE_44, hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, label: confirmLabel, onClick: handleCloseBottomSheet }) },
        React.createElement(FilterListWrapperStyled, null,
            React.createElement(FilterListStyled, { isRightToLeft: isRightToLeft }, radioButtonItems)))), [
        isExpanded,
        handleCloseBottomSheet,
        titleLabel,
        confirmLabel,
        isRightToLeft,
        radioButtonItems,
    ]);
    return isDesktop ? ListDesktop : ListMobile;
});
RadioButtonsDropdown.displayName = 'RadioButtonsDropdown';
